var map = {
	"./account/account.module": [
		"./src/app/routes/account/account.module.ts",
		"common",
		"account-account-module"
	],
	"./bi/bi.module": [
		"./src/app/routes/bi/bi.module.ts",
		"default~bi-bi-module~individual-individual-module",
		"common",
		"bi-bi-module"
	],
	"./company/company.module": [
		"./src/app/routes/company/company.module.ts",
		"common",
		"company-company-module"
	],
	"./consult/consult.module": [
		"./src/app/routes/consult/consult.module.ts",
		"consult-consult-module"
	],
	"./declaration/declaration.module": [
		"./src/app/routes/declaration/declaration.module.ts",
		"declaration-declaration-module"
	],
	"./entry/entry.module": [
		"./src/app/routes/entry/entry.module.ts",
		"common",
		"entry-entry-module"
	],
	"./fields/fields.module": [
		"./src/app/routes/fields/fields.module.ts",
		"fields-fields-module"
	],
	"./home/home.module": [
		"./src/app/routes/home/home.module.ts",
		"default~home-home-module~pib-pib-module",
		"common",
		"home-home-module"
	],
	"./indextype/indextype.module": [
		"./src/app/routes/indextype/indextype.module.ts",
		"indextype-indextype-module"
	],
	"./individual/individual.module": [
		"./src/app/routes/individual/individual.module.ts",
		"default~bi-bi-module~individual-individual-module",
		"default~individual-individual-module~pib-pib-module",
		"common",
		"individual-individual-module"
	],
	"./person/person.module": [
		"./src/app/routes/person/person.module.ts",
		"common",
		"person-person-module"
	],
	"./pib-individual/pib-individual.module": [
		"./src/app/routes/pib-individual/pib-individual.module.ts",
		"pib-individual-pib-individual-module"
	],
	"./pib/pib.module": [
		"./src/app/routes/pib/pib.module.ts",
		"default~home-home-module~pib-pib-module",
		"default~individual-individual-module~pib-pib-module",
		"pib-pib-module"
	],
	"./webshop/webshop.module": [
		"./src/app/routes/webshop/webshop.module.ts",
		"webshop-webshop-module"
	],
	"./zzi/zzi.module": [
		"./src/app/routes/zzi/zzi.module.ts",
		"zzi-zzi-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;